import { cn } from "../../lib/utils";

/**
 * Grille de checkboxes pour les champs enum multi-valeurs.
 * Props :
 *  - label : libellé du groupe
 *  - options : [{value, label}]
 *  - value : string[] (valeurs sélectionnées)
 *  - onChange : (newValues: string[]) => void
 *  - columns : nombre de colonnes (défaut 2)
 */
export default function CheckboxGrid({
  label,
  options = [],
  value = [],
  onChange,
  columns = 2,
  error,
  className,
}) {
  const toggle = (optValue) => {
    const next = value.includes(optValue)
      ? value.filter((v) => v !== optValue)
      : [...value, optValue];
    onChange(next);
  };

  return (
    <div className={cn("space-y-1", className)}>
      {label && (
        <span className="block text-sm font-medium text-slate-700">{label}</span>
      )}
      <div
        className="grid gap-2"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={value.includes(opt.value)}
              onChange={() => toggle(opt.value)}
              className="rounded border-slate-300 text-carex-600 focus:ring-carex-500"
            />
            {opt.label}
          </label>
        ))}
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
